// components/icons/RightArrow.tsx
import React from 'react'

const RightArrow: React.FC = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      height="32"
      width="32"
      viewBox="0 0 492 492"
      {...props}
    >
      <path
        d="M293.392,245.896L109.336,429.96c-5.068,5.056-7.856,11.816-7.856,19.024c0,7.212,2.788,13.968,7.856,19.032l16.128,16.12
        c5.068,5.072,11.832,7.864,19.04,7.864s13.964-2.792,19.028-7.864l219.148-219.144c5.084-5.08,7.868-11.868,7.848-19.084
        c0.02-7.248-2.76-14.028-7.848-19.112L163.532,7.864C158.468,2.792,151.712,0,144.504,0c-7.208,0-13.964,2.792-19.032,7.864
        l-16.124,16.12c-10.492,10.492-10.492,27.572,0,38.06L293.392,245.896z"
      />
    </svg>
  )
}

export default RightArrow
